import CheckoutSuccess from '../components/CheckoutSuccess';
import React from 'react';
import Banner from '../components/Banner';
import Footer from '../components/Footer';


const CheckoutSuccessPage: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Banner />
      <div style={{ flex: 1 }}>
        <CheckoutSuccess />
      </div>
      <Footer />
    </div>
  );
};

export default CheckoutSuccessPage;

